import _ from "lodash";

export const ROUTES = {
  home: "/",
  import: "/import",
  live: "/live",
  players: "/players",
  profile: "/profile",
  callback: "/callback",
  teams: {
    list: "/teams",
    homePage: "/teams/:id",
    home: "/teams/:id/home",
    stats: "/teams/:id/season-stats",
    roster: "/teams/:id/roster",
    teamInfo: "/teams/:id/team-info",
    schedule: "/teams/:id/schedule",
    pitchSmart: "/teams/:id/pitch-smart",
    users: "/teams/:id/users",
    publicPlayerProfile: {
      stats: "/teams/:id/players/:pid/player-profile",
      sprayChart: "/teams/:id/players/:pid/player-profile/spray-chart",
      clips: "/teams/:id/players/:pid/player-profile/clips",
      schedule: "/teams/:id/players/:pid/player-profile/schedule",
      eventDetail: "/teams/:id/players/:pid/player-profile/schedule/:eid/detail",
    },
    playerProfile: "/teams/:id/players/:pid",
    events: {
      event: "/teams/:id/events/:eid",
      schedule: "/teams/:id/schedule",
      scheduleEvent: "/teams/:id/schedule/:eid",
      plays: "/teams/:id/schedule/:eid/plays",
      gameStats: "/teams/:id/schedule/:eid/game-stats",
      startingLineup: "/teams/:id/schedule/:eid/starting-lineup",
      liveStream: "/teams/:id/schedule/:eid/live",
      boxScore: "/teams/:id/schedule/:eid/box-score",
      videos: "/teams/:id/schedule/:eid/videos",
    },
  },
  styleGuide: "/style-guide",
  appInfo: "/app-info",
  login: "/login",
  checkYourEmail: "/check-your-email",
  tokenLogin: "/token-login",
} as const;

export const STATIC_REDIRECT_ROUTES: { from: string; to: string }[] = [
  {
    from: ROUTES.teams.homePage,
    to: ROUTES.teams.home,
  },
  // team-setup routes now all redirect to ROUTES.teams.schedule
  ...[
    "/team-setup/:teamID/add-events",
    "/team-setup/:teamID/add-roster",
    "/team-setup/:teamID/add-staff",
    "/team-setup/:teamID/add-schedule",
    "/team-setup/:teamID/success",
  ].map((r) => ({ from: r, to: ROUTES.teams.events.schedule })),
  // redirect / to login (which will then redirect to teams.list(if user is logged in)
  { from: ROUTES.home, to: ROUTES.login },
];

export const ROUTES_WITHOUT_LOGIN = [
  /\/style-guide/,
  /\/app-info/,
  /\/teams\/.*\/events\/.*/,
  /\/player-profile/,
  /\/teams\/.*\/schedule\/.*\/live/,
];

const all_routes = (routes: object): string[] => _.flatMap(routes, (r) => (typeof r === "object" ? all_routes(r) : r));

export const ROUTES_WITH_FOOTER: string[] = all_routes(ROUTES)
  .filter((r) => !r.includes("/teams/"))
  .filter((r) => !r.includes("/organizations/"))
  .filter((r) => !r.includes("style-guide"))
  .filter((r) => !r.includes("app-info"))
  .filter((r) => !r.includes("events")); // Magic link RSVP page

export const ROUTES_WITH_BACK_TO_SCHEDULE_HEADER: string[] = all_routes(ROUTES)
  .filter((r) => r.includes("/schedule/"))
  .filter((r) => !r.endsWith("live")); // Live page.

export const ROUTES_WITH_TEAM_NAV: string[] = all_routes(ROUTES).filter(
  (r) => !ROUTES_WITH_BACK_TO_SCHEDULE_HEADER.includes(r)
);

export const ROUTES_WITH_TEAMS: string[] = all_routes(ROUTES).filter((r) => r.includes("/teams"));
export const ROUTES_WITH_EVENTS: string[] = all_routes(ROUTES).filter(
  (r) => r.includes("/schedule") || r.includes("/events")
);
